(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["auto-banner"] && !Shopify.designMode) return;
  try {
    
    const toAnimate = document.querySelectorAll('.animate');
    animationObserver = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.intersectionRatio > 0) {
            entry.target.classList.add('arrive');
            animationObserver.unobserve(entry.target);
            } else {
            entry.target.classList.remove('arrive');
            }
        });
    });

    toAnimate.forEach(item => {
        animationObserver.observe(item);
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["casual-banner"] && !Shopify.designMode) return;
  try {
    
    const toAnimate = document.querySelectorAll('.animate');
    animationObserver = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.intersectionRatio > 0) {
            entry.target.classList.add('arrive');
            animationObserver.unobserve(entry.target);
            } else {
            entry.target.classList.remove('arrive');
            }
        });
    });

    toAnimate.forEach(item => {
        animationObserver.observe(item);
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dynamic-banner"] && !Shopify.designMode) return;
  try {
    
    const toAnimate = document.querySelectorAll('.animate');
    animationObserver = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.intersectionRatio > 0) {
            entry.target.classList.add('arrive');
            animationObserver.unobserve(entry.target);
            } else {
            entry.target.classList.remove('arrive');
            }
        });
    });

    toAnimate.forEach(item => {
        animationObserver.observe(item);
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mtb-banner"] && !Shopify.designMode) return;
  try {
    
    const toAnimate = document.querySelectorAll('.animate');
    animationObserver = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.intersectionRatio > 0) {
            entry.target.classList.add('arrive');
            animationObserver.unobserve(entry.target);
            } else {
            entry.target.classList.remove('arrive');
            }
        });
    });

    toAnimate.forEach(item => {
        animationObserver.observe(item);
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mx-banner"] && !Shopify.designMode) return;
  try {
    
    const toAnimate = document.querySelectorAll('.animate');
    animationObserver = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.intersectionRatio > 0) {
            entry.target.classList.add('arrive');
            animationObserver.unobserve(entry.target);
            } else {
            entry.target.classList.remove('arrive');
            }
        });
    });

    toAnimate.forEach(item => {
        animationObserver.observe(item);
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-manuals"]) return;
  try {
    
    $('#manual-search').keyup(function(){
    var valThis = $(this).val().toLowerCase();
        if(valThis == ""){
            $('.manual-list > li').show("fast");
        } else {
            $('.manual-list > li').each(function(){
                var text = $(this).text().toLowerCase();
                (text.indexOf(valThis) >= 0) ? $(this).show("fast") : $(this).hide("fast");
            });
    };
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["road-banner"] && !Shopify.designMode) return;
  try {
    
    const toAnimate = document.querySelectorAll('.animate');
    animationObserver = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.intersectionRatio > 0) {
            entry.target.classList.add('arrive');
            animationObserver.unobserve(entry.target);
            } else {
            entry.target.classList.remove('arrive');
            }
        });
    });

    toAnimate.forEach(item => {
        animationObserver.observe(item);
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["static-sr10"]) return;
  try {
    
    const comingSoon = document.querySelectorAll('.soon-button');

    comingSoon.forEach(link => {
        link.addEventListener('click', function (){
        var _klOnsite = window._klOnsite || [];
            _klOnsite.push(['openForm', 'UpbCk4']);
      });
    });

    const toAnimate = document.querySelectorAll('.animate');
    animationObserver = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.intersectionRatio > 0) {
            entry.target.classList.add('arrive');
            animationObserver.unobserve(entry.target);
            } else {
            entry.target.classList.remove('arrive');
            }
        });
    });

    toAnimate.forEach(item => {
        animationObserver.observe(item);
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["touring-banner"] && !Shopify.designMode) return;
  try {
    
    const toAnimate = document.querySelectorAll('.animate');
    animationObserver = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.intersectionRatio > 0) {
            entry.target.classList.add('arrive');
            animationObserver.unobserve(entry.target);
            } else {
            entry.target.classList.remove('arrive');
            }
        });
    });

    toAnimate.forEach(item => {
        animationObserver.observe(item);
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["urban-banner"] && !Shopify.designMode) return;
  try {
    
    const toAnimate = document.querySelectorAll('.animate');
    animationObserver = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.intersectionRatio > 0) {
            entry.target.classList.add('arrive');
            animationObserver.unobserve(entry.target);
            } else {
            entry.target.classList.remove('arrive');
            }
        });
    });

    toAnimate.forEach(item => {
        animationObserver.observe(item);
    });

  } catch(e) { console.error(e); }
})();
})();
